// extracted by mini-css-extract-plugin
module.exports = {"error":"Error_error__t0acB","button":"Error_button__EAfT9"};